import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-screen-2xl mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
            分类<span className="text-accent-500">导航</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按分类浏览，找到你想吃的瓜
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to="/"
              className="group cursor-pointer"
            >
              <div className="rounded-lg border border-foreground-200/40 bg-background-50 p-5 md:p-6 text-center transition-all duration-300 group-hover:border-accent-300/60 group-hover:bg-accent-50/50">
                <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center transition-all duration-300 group-hover:bg-accent-200/60">
                  <i className={`${cat.icon} text-xl md:text-2xl text-secondary-600 transition-colors duration-300 group-hover:text-accent-600`}></i>
                </div>
                <h3 className="text-sm md:text-base font-label font-semibold text-foreground-800 mb-1 group-hover:text-accent-700 transition-colors duration-200">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">
                  {cat.count.toLocaleString()} 篇
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}